import React from 'react';
import styled from 'styled-components';

// `flush` cards (Message Inputs, Subscriber Details) drop their padding and
// clip their children so each row can render its own bottom border edge-to-
// edge — the last row's border meets the card's outer border at the corner.
// Non-flush cards keep an internal gap for stacked content blocks.
const SectionCardWrapper = styled.section<{ $flush: boolean }>`
  background: var(--surface-bkg-color);
  border: 1px solid var(--border-color-dim);
  border-radius: var(--border-radius-small);
  display: flex;
  flex-direction: column;
  ${({ $flush }) =>
    $flush
      ? `padding: 0; overflow: hidden;`
      : `padding: var(--spacing-3); gap: var(--spacing-2);`}
`;

interface SectionCardProps {
  ariaLabelledBy?: string;
  children: React.ReactNode;
  flush?: boolean;
}

export const SectionCard: React.FC<SectionCardProps> = ({
  ariaLabelledBy,
  children,
  flush = false,
}) => (
  <SectionCardWrapper aria-labelledby={ariaLabelledBy} $flush={flush}>
    {children}
  </SectionCardWrapper>
);
